import type { ServerMenuDataItem } from '@/types/menu';

/**
 * 从服务端菜单中提取所有合法路由 path
 * @param menuList 服务端返回的菜单列表
 * @returns 合法路由 path 数组（去重）
 */
export const extractValidRoutesFromMenu = (menuList: ServerMenuDataItem[]): string[] => {
  const validRoutes: string[] = [];

  const recursionExtract = (menus: ServerMenuDataItem[]) => {
    menus.forEach(menu => {
      // 过滤空 path（如分隔符菜单）
      if (menu.path && menu.path.trim()) {
        validRoutes.push(menu.path);
      }
      // 递归处理子菜单
      if (menu.children && menu.children.length > 0) {
        recursionExtract(menu.children);
      }
    });
  };

  recursionExtract(menuList);
  // 去重 + 排序（可选）
  return [...new Set(validRoutes)];
};

/**
 * 校验当前路径是否在合法路由列表中
 * @param currentPath 当前访问的路径
 * @param validRoutes 合法路由列表
 * @param whiteList 白名单路径（无需校验）
 * @returns 是否合法
 */
export const isRouteValid = (
  currentPath: string,
  validRoutes: string[],
  whiteList: string[] = []
): boolean => {
  // 白名单路径直接放行（如登录页、403/404、首页等）
  if (whiteList.some(path => currentPath.startsWith(path))) {
    return true;
  }
  // 精确匹配合法路由（支持模糊匹配，如 /system/* 可自行扩展）
  return validRoutes.includes(currentPath);
};
